import { useEffect } from 'react';

/**
 * 브라우저 뒤로가기 시 페이지를 새로고침하는 훅
 * popstate 이벤트와 pageshow 이벤트를 감지하여 뒤로가기 시 window.location.reload()를 실행합니다.
 * iOS Safari와 Chrome의 BFCache 문제를 해결하기 위해 pageshow 이벤트도 함께 처리합니다.
 */
export const useBrowserBackReload = () => {
  const checkIsLoginPage = (): boolean => {
    return window.location.pathname === '/oauth/login';
  };

  const checkTokenIsExists = (): boolean => {
    return !!localStorage.getItem('@accessToken');
  };

  const checkIsTokenExistsAndLoginPage = (): boolean => {
    return checkIsLoginPage() && checkTokenIsExists();
  };

  const reloadPageWhenTokenExistsAndLoginPage = () => {
    if (checkIsTokenExistsAndLoginPage()) {
      window.location.reload();
    }
  };

  useEffect(() => {
    const handlePopState = () => {
      reloadPageWhenTokenExistsAndLoginPage();
    };

    const handlePageShow = (event: PageTransitionEvent) => {
      if (event.persisted) {
        reloadPageWhenTokenExistsAndLoginPage();
      }
    };

    // popstate 이벤트 리스너 등록 (데스크톱 브라우저용)
    window.addEventListener('popstate', handlePopState);

    // pageshow 이벤트 리스너 등록 (모바일 브라우저용, BFCache 대응)
    window.addEventListener('pageshow', handlePageShow);

    // 컴포넌트 언마운트 시 이벤트 리스너 제거
    return () => {
      window.removeEventListener('popstate', handlePopState);
      window.removeEventListener('pageshow', handlePageShow);
    };
  }, []);
};
